import React, { useState, useEffect } from "react";
import APIService from "../../Services/API/APIService";
import {
  Form,
  Segment,
  Divider,
  Dimmer,
  Loader,
  Radio,
  Modal,
} from "semantic-ui-react";
import Big from "big.js";

import numeral from "numeral";
import SavingsWithdrawal from "./SavingsWithdrawal";
import DirectTransfer from "./DirectTransfer";
import BookingConfirm from "./BookingConfirm";
import productType from "../../Data/ProductTypes";
import CoopDebit from "./CoopDebit";
import Invoice from "./Invoice";
import PosPayment from "./PosPayment";



const Payment = (props) => {

  const [user] = useState(APIService.fetchUser());
  const [loading, setLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState(null);
  const [iggModalState, toggleIggModal] = useState(false);
  const [coopDebitModalState, toggleCoopDebitModal] = useState(false);
  const [invoiceModalState, toggleInvoiceModal] = useState(false);
  const [bookingModalState, toggleBookingModal] = useState(false);
  const [directTransferModalState, toggleDirectTransferModal] = useState(false);
  const [posModalState, togglePosModal] = useState(false);
  const [paystackCharge, setPaystackCharge] = useState(null);


  useEffect(() => {
    let isSubscribed = true
    _computePayStackTxCharge(props.amountDue);
    fetchData(isSubscribed);
    return () => (isSubscribed = false)
  }, [props.amountDue]);

  const fetchData = async (isSubscribed) => {
    try {
      setLoading(true);
      if(isSubscribed){
        
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };


  const _computePayStackTxCharge = (total) => {
    let flatCharge = Big(100);

    if (total < 2500) {
      flatCharge = 0;
    }

    let txCharge = Big(total).times(0.015).times(1.015).plus(flatCharge);

    if (txCharge.gt(2000)) {
      setPaystackCharge(2000);
    } else {
      setPaystackCharge(txCharge);
    }
  };


  const payWithPaystack = () => {
    var handler = window.PaystackPop.setup({
      key: process.env.REACT_APP_PAYSTACK_KEY,


      email: user.email,
      amount: Big(props.amountDue).plus(paystackCharge).times(100).round(),
      first_name: user.firstname,
      last_name: user.lastname,
      phone: user.phone,
      metadata: {
        guesthouse_payment_id: String(props.reference),
        custom_fields: [
          {
            display_name: user.name,
            variable_name: "mobile_number",
            value: user.phoneNumber,
          },
        ],
      },
      callback: (response) => {
        props.completeBooking(response, "PAYSTACK", props.amountDue);

      },
      onClose: () => {
        setPaymentMode(null);
      },
    });
    handler.openIframe();
  };



  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Segment>
        <h4>Amount Due: ₦{numeral(props.amountDue).format("0,0.00")}</h4>
        <Divider />

        <Form loading={loading}>
          {(user?.group.includes("ADMIN") || user?.group.includes("SUPERADMIN")) && (
            <Form.Field>
              <Radio
                label="Pay with POS"
                name="radioGroup"
                value="POS"
                checked={paymentMode === "POS"}
                onChange={(e, { value }) => {
                  setPaymentMode(value);
                  togglePosModal(true);
                }}
              />
            </Form.Field>
          )}

               
          {(!user?.group.includes("ADMIN") && !user?.group.includes("SUPERADMIN"))  && (
            <Form.Field>
              <Radio
                label={`Pay with Debit Card [Incurres a transaction charge of ₦ ${numeral(
                  paystackCharge
                ).format("0,0.00")}]`}
                name="radioGroup"
                value="PAYSTACK"
                checked={paymentMode === "PAYSTACK"}
                onChange={(e, { value }) => {
                  setPaymentMode(value);
                  payWithPaystack();
                }}
              />
            </Form.Field>
          )}

          <Form.Field>
            <Radio
              label={`Pay with Direct Payment [Transfer to ${productType.GUESTHOUSE.bank} - ${productType.GUESTHOUSE.accountNumber}. Use reference number #: ${props.reference}]`}
              name="radioGroup"
              value="DIRECT_TRANSFER"
              checked={paymentMode === "DIRECT_TRANSFER"}
              onChange={(e, { value }) => {
                setPaymentMode(value);
                toggleDirectTransferModal(true);
              }}
            />
          </Form.Field>



          {user?.group.includes("COOPERATOR") && (
            <>
              <Form.Field>
                <Radio
                  label="Pay with Coop Savings"
                  name="radioGroup"
                  value="COOP_SAVINGS"
                  checked={paymentMode === "COOP_SAVINGS"}
                  onChange={(e, { value }) => {
                    setPaymentMode(value);
                    toggleIggModal(true);
                  }}
                />
              </Form.Field>
            </>
          )}


          {(user?.group.includes("ADMIN") || user?.group.includes("SUPERADMIN"))  && (
            <>
              <Form.Field>
                <Radio
                  label="Pay with Coop Debit"
                  name="radioGroup"
                  value="COOP_DEBIT"
                  checked={paymentMode === "COOP_DEBIT"}
                  onChange={(e, { value }) => {
                    setPaymentMode(value);
                    toggleCoopDebitModal(true);
                  }}
                />
              </Form.Field>
            </>
          )}

      

          {(user?.group.includes("ADMIN") || user?.group.includes("SUPERADMIN"))  &&  (props.checkout == null) && (
            <>
              <Form.Field>
                <Radio
                  label="ReservePayment"
                  name="radioGroup"
                  value=''
                  checked={paymentMode === ''}
                  onChange={(e, { value }) => {
                    setPaymentMode(value);
                    toggleInvoiceModal(true);
                  }}
                />
              </Form.Field>
            </>
          )}
        </Form>
      </Segment>

      <Modal
        size="mini"
        open={iggModalState}
        onClose={() => {
          toggleIggModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <SavingsWithdrawal
            toggleModal={toggleIggModal}
            total={props.amountDue}
            bizUnit={props.bizUnit}
            reference={props.reference}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>


      <Modal
        size="mini"
        open={bookingModalState}
        onClose={() => {
          toggleBookingModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <BookingConfirm
            toggleModal={toggleBookingModal}
            total={props.amountDue}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>

      <Modal
        size="mini"
        open={directTransferModalState}
        onClose={() => {
          toggleDirectTransferModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <DirectTransfer
            toggleModal={toggleDirectTransferModal}
            total={props.amountDue}
            reference={props.reference}
            reservationToken={props.reservationToken}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>

 
      <Modal
        size="mini"
        open={coopDebitModalState}
        onClose={() => {
          toggleCoopDebitModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <CoopDebit toggleModal={toggleCoopDebitModal}
            total={props.amountDue}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>

      <Modal
        size="mini"
        open={invoiceModalState}
        onClose={() => {
          toggleInvoiceModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <Invoice toggleModal={toggleInvoiceModal}
            total={props.amountDue}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>

      
      <Modal
        size="mini"
        open={posModalState}
        onClose={() => {
          togglePosModal(false);
          setPaymentMode(null);
        }}
        closeIcon
      >
        <Modal.Content>
          <PosPayment
            toggleModal={togglePosModal}
            total={props.amountDue}
            paymentMode={paymentMode}
            onSuccess={props.completeBooking}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default Payment;
